<template>
  <PlaceholderPantalla
    titulo="Insumos y Materiales de Impresión"
    subtitulo="Control de inventario de materiales, tintas y consumibles"
    descripcion="Administra todos los insumos necesarios para la operación de impresión: papeles, lonas, vinilos, tintas, tóners, cartuchos y consumibles. Controla stocks, precios de compra, proveedores, niveles mínimos y máximos, y recibe alertas automáticas cuando necesites reordenar."
    :funcionalidades="funcionalidades"
    :datos-manejados="datosManejados"
    :mostrar-mockup="true"
  />
</template>

<script setup>
import PlaceholderPantalla from '../../Finanzas/PlaceholderPantalla.vue'

const funcionalidades = [
  'Catálogo completo de insumos y materiales de impresión',
  'Categorizar por tipo (Papeles, Tintas, Vinilos, Lonas, Consumibles, etc.)',
  'Control de stock en tiempo real con múltiples unidades de medida',
  'Registro de entradas de inventario con fecha y proveedor',
  'Registro de salidas de inventario (manual o automático al producir)',
  'Definir niveles mínimos y máximos de stock',
  'Alertas automáticas cuando stock llega al mínimo',
  'Precio de compra promedio ponderado',
  'Múltiples proveedores por insumo',
  'Conversión automática de unidades (hojas, pliegos, metros, ml, etc.)',
  'Historial completo de movimientos de inventario',
  'Valuación de inventario (PEPS, UEPS, Promedio)',
  'Generar lista de compras automática',
  'Control de lotes y números de serie (tintas/tóners)',
  'Importar/exportar inventario'
]

const datosManejados = [
  'Nombre del insumo/material',
  'Categoría (Papeles, Tintas, Vinilos, Lonas, Consumibles)',
  'Especificaciones técnicas (gramaje, tamaño, color, acabado)',
  'Unidad de medida base (hojas, pliegos, metros, litros, pz)',
  'Conversiones de unidades',
  'Stock actual en almacén',
  'Stock mínimo (punto de reorden)',
  'Stock máximo',
  'Precio de compra actual',
  'Precio promedio ponderado',
  'Proveedor principal',
  'Proveedores alternos',
  'Fecha de última compra',
  'Lote o número de serie',
  'Ubicación en almacén',
  'Código interno / SKU',
  'Historial de movimientos (entradas/salidas)',
  'Observaciones y notas'
]
</script>
